import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'amountNounTranslation'
})
export class AmountNounTranslationPipe implements PipeTransform {

  private translationsContainer: string;
  private zeroAmountCustomTranslation: boolean;

  constructor(private ts: TranslateService) {
  }

  transform(total: number, translationsContainer: string, zeroAmountCustomTranslation: boolean = false): any {
    this.translationsContainer = translationsContainer;
    this.zeroAmountCustomTranslation = zeroAmountCustomTranslation;
    const translationString = this.getTranslationString(total);
    return this.ts.get(translationString)
  }

  private getTranslationString(total: number): string {

    switch (total) {
      case 0:
        if (this.zeroAmountCustomTranslation) {
          return this.getFullTranslationKey('haveFoundZero'); // Brak ofert
        } else {
          return this.getFullTranslationKey('haveFoundMany'); // ofert
        }
      case 1:
        return this.getFullTranslationKey('haveFoundOne'); // ofertę
      default:
        if (total >= 5 && total <= 21) {
          return this.getFullTranslationKey('haveFoundMany'); // ofert
        } else {
          const unitsDigit = total % 10;
          if (unitsDigit >= 2 && unitsDigit <= 4) {
            return this.getFullTranslationKey('haveFoundPolishCondition'); // oferty
          } else {
            return this.getFullTranslationKey('haveFoundMany'); // ofert
          }
        }
    }
  }

  private getFullTranslationKey(subKey: string) {
    return `${this.translationsContainer}.${subKey}`;
  }

}
